// ====================================================================================
// mainMenu.module
// ====================================================================================
import $ from "jquery";

export const init = () => {
  let attempts = 0;

  const header = document.querySelector("header");
  const burgerBtn = $(
    header.querySelector(".btn--burger") ||
      header.querySelector(".btn--burger-2")
  );
  const mainNav = $(header).find(".main-nav");
  const flyoutMenu = $(header).next().next();
  const isClinic = document.querySelector(".btn--burger-2") ? true : false;

  let scrollStart = document.querySelector(".banner") ? 159 : 7;
  let isWideScreen = window.innerWidth > 991;
  let isHeaderMini = false;
  let isFlyoutHidden = true;
  let lastWidth = window.innerWidth;
  let resizeInterval = null;

  const updateIntroHeight = function () {
    let intro = document.querySelector(".intro");
    let bottomNav = document.querySelector(".header__bottom-nav");
    let bottomNavHeight = null;

    if (!intro || !bottomNav) return;

    if (window.innerWidth <= 991) {
      bottomNavHeight = bottomNav.offsetHeight;
      if (bottomNav.classList.contains("open")) {
        bottomNavHeight = bottomNav.querySelector(".toggle-btn").offsetHeight;
      }

      let headerHeight = header.offsetHeight;
      let newHeight = bottomNavHeight + headerHeight;
      intro.style.marginTop = `${newHeight}px`;
    } else {
      intro.removeAttribute("style");
    }
  };

  // Scroll
  $(window).on("scroll", function (e) {
    let sc = window.scrollY || window.pageYOffset;

    if (sc > scrollStart) {
      if (isHeaderMini) return;
      header.classList.add("header--mini");
      isHeaderMini = true;
    } else {
      if (header.classList.contains("header--mini")) {
        header.classList.remove("header--mini");
        isHeaderMini = false;
      }
    }
  });

  // On page load with offset
  if ((window.scrollY || window.pageYOffset) > 159) {
    header.classList.add("header--mini");
  }

  // Method to hide mobile flyout
  const hideMobileMainNav = function () {
    $(mainNav).addClass("main-nav--hidding").removeClass("show");
    setTimeout(function () {
      $(mainNav).removeClass("main-nav--hidding");
    }, 500);
  };

  const showFlyoutMenu = function (menu, isMobile) {
    isFlyoutHidden = false;

    if (isMobile) {
      menu.each(function () {
        $(this).removeClass("d-none").addClass("show");
      });

      return;
    }

    if (!flyoutMenu.hasClass("show")) {
      $(header).find(".header__right").addClass("d-none");
      $(header).addClass("header--opened-flyout");
      flyoutMenu.addClass("show");
      $("body").bind("click", clickOutFlyoutHandler);
    }

    menu.siblings(".show").removeClass("show").addClass("d-none");
    menu.removeClass("d-none").addClass("show");
  };

  // Unility to hide flyout with CSS effect
  const closeFlyoutMenu = function (closeMenu) {
    if (isFlyoutHidden) return;

    burgerBtn.removeClass("active");

    $(header).removeClass("header--opened-flyout");
    $(header).find(".header__right").removeClass("d-none");
    flyoutMenu.addClass("hide").removeClass("show");
    isFlyoutHidden = true;

    setTimeout(function () {
      flyoutMenu.removeClass("hide");
      flyoutMenu
        .find("[data-category].show")
        .removeClass("show")
        .addClass("d-none");
    }, 500);

    if (isClinic) {
      document
        .querySelector(".header-claim-container")
        .classList.remove("d-none");
      document.querySelector(".main-nav").classList.add("d-none");
      document.querySelector(".header__right--2").classList.remove("d-none");
      document.querySelector(".main-nav--2").classList.remove("d-none");
      document.querySelector(".header__bottom-nav").classList.remove("d-none");
    }

    if (closeMenu) {
      $(mainNav).find("ul").children().removeAttr("style");
      hideMobileMainNav();
    }
  };

  // Handle click event outside of flyout menu
  const clickOutFlyoutHandler = function (e) {
    const targetElem = $(e.target);

    if (
      targetElem.closest(flyoutMenu).length ||
      targetElem.closest($(mainNav)).length ||
      (targetElem.closest($(header)).length &&
        !$(flyoutMenu).find(".flyout-menu-close").length)
    ) {
      return;
    }

    $(mainNav).find("li").removeClass("active");
    burgerBtn.removeClass("active");
    closeFlyoutMenu(true);

    $("body").unbind("click", clickOutFlyoutHandler);
  };

  const flyoutEventHandler = function (e) {
    const dataMenu = $(this).data("menu");

    if ($(this).hasClass("direct-link")) {
      $(this).find("a")[0].click();
      return;
    }

    // If no data-menu dataset, perform default action
    if (!dataMenu || window.innerWidth < 992) return;

    e.preventDefault();

    // Close flyout in case of attempt to activate the same link
    if (
      e.type === "click" &&
      $(this).hasClass("active") &&
      flyoutMenu.hasClass("show")
    ) {
      $(this).removeAttr("style").removeClass("active");
      closeFlyoutMenu();
      return;
    }

    // Activate a new item in main navigation
    $(this).siblings(".active").removeClass("active");
    $(this).addClass("active");

    // Activate needed flyout group
    const menu = flyoutMenu.find(`[data-category="${dataMenu}"]`);

    if (!menu.length) return;

    if (!isWideScreen) {
      // Place flyout with category (mobile screen)
      $(this).siblings().removeAttr("style");
    } else {
      // Show flyout with category (large screen)
      if (menu.length) {
        showFlyoutMenu(menu, false);
      } else {
        console.warn(
          `%cMenu category "${dataMenu}" is not found in flyout.`,
          warnStyle
        );
      }
    }
  };

  $(mainNav).find("li").on("click", flyoutEventHandler);
  // $(flyoutMenu).find(".flyout-menu-close").on("click", closeFlyoutMenu);
  $(".flyout-menu-close").on("click", closeFlyoutMenu);

  // Header
  burgerBtn.on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");

    if ($(flyoutMenu).hasClass("show")) {
      $(header).removeClass("header--opened-flyout");
      $(flyoutMenu).removeClass("show");
      if (isClinic) {
        document
          .querySelector(".header-claim-container")
          .classList.remove("d-none");
        document.querySelector(".main-nav").classList.add("d-none");
        document.querySelector(".header__right--2").classList.remove("d-none");
        document.querySelector(".main-nav--2").classList.remove("d-none");
        document
          .querySelector(".header__bottom-nav")
          .classList.remove("d-none");
      }

      isFlyoutHidden = true;
    } else {
      $(header).addClass("header--opened-flyout");

      // Activate all categories as screen is mobile

      // show first or all menues
      let menues = flyoutMenu.find("[data-category]");
      if (isWideScreen) menues = menues.toArray().slice(0, 1);
      showFlyoutMenu($(menues), true);

      $(flyoutMenu).addClass("show");
      if (isClinic) {
        document
          .querySelector(".header-claim-container")
          .classList.add("d-none");
        document.querySelector(".main-nav").classList.remove("d-none");
        document.querySelector(".header__right--2").classList.add("d-none");
        document.querySelector(".main-nav--2").classList.add("d-none");
        document.querySelector(".header__bottom-nav").classList.add("d-none");
      }

      isFlyoutHidden = false;
    }
  });

  // Flyout subcategories
  $(flyoutMenu)
    .find(".subcategory > span")
    .on("click", function (e) {
      if (window.innerWidth <= 991) {
        e.preventDefault();
        let $this = $(this).parent();
        let listElem = $this.children("ul");
        let subcategory = $this.closest(".subcategory");

        if (subcategory.hasClass("active")) {
          listElem.css("opacity", 0);

          setTimeout(function () {
            subcategory.removeClass("active");
          }, 400);
        } else {
          listElem.css("opacity", 1);
          subcategory.addClass("active");
        }
      }
    });

  $(window).on("resize", function (e) {
    if (!e.isTrigger) {
      if (window.innerWidth !== lastWidth) {
        clearInterval(resizeInterval);
        resizeInterval = setInterval(() => {
          if (window.innerWidth <= 991 && lastWidth > 991) {
            location.reload();
          }
          if (window.innerWidth > 991 && lastWidth <= 991) {
            location.reload();
          }

          updateIntroHeight();
          clearInterval(resizeInterval);
        }, 400);
      }

      lastWidth = window.innerWidth;
    }
  });

  $(".bg-vid-btn").on("click", function (e) {
    e.preventDefault();
    let next = $(e.target).parents(".intro").next();
    if (next.length > 0) {
      $("html, body").animate(
        {
          scrollTop: next.offset().top - 120,
        },
        400
      );
    }
  });

  const gridWrapMenus = $(".grid-wrap .flyout-menu__list")
  gridWrapMenus.each((i, v)  => {

    let subcategory = $(v).find('.subcategory')
    let label = subcategory.find('span')
    label.on('click', () => {

      let wasActive = subcategory.hasClass('active')
      gridWrapMenus.find('.subcategory').removeClass('active')

      if(!wasActive)
        subcategory.addClass('active')

    })

  })

  updateIntroHeight();

  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      let fluoutLinks = $(".asfodm");
      if (fluoutLinks.length > 0) {
        fluoutLinks.each(function () {
          let href = $(this).attr("href");
          let asfodm = href.match(/asfodm=(\d+)/);
          if (asfodm) {
            $(this).on("click", function (e) {
              e.preventDefault();
              if (window.innerWidth <= 991) {
                $(".btn.btn--burger").trigger("click");
              } else {
                setTimeout(() => {
                  $(`[data-menu="${asfodm[1]}"]`).trigger("click");
                }, 100);
              }
            });
          }
        });
      }
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
